/**
 * Item request capture — compose title from structured taxonomy (no free-text identity).
 * H7: Category · subcategory (not subcategory alone).
 */

export function composeItemRequestTitle(input: {
  categoryName: string;
  subcategoryName: string;
}): string {
  const category = input.categoryName.trim();
  const subcategory = input.subcategoryName.trim();
  if (!subcategory && !category) return "";
  if (!subcategory) return category;
  if (!category || category.toLowerCase() === subcategory.toLowerCase()) {
    return subcategory;
  }
  return `${category} · ${subcategory}`;
}

/** Optional notes stored as description — capped so they cannot replace structure. */
export const ITEM_REQUEST_NOTES_MAX_LEN = 280;

export function normalizeItemRequestNotes(
  raw: string | undefined | null,
): string {
  if (!raw) return "";
  return raw.trim().slice(0, ITEM_REQUEST_NOTES_MAX_LEN);
}
